import React from "react"
import { DropdownButton } from "react-bootstrap"
import Dropdown from "react-bootstrap/Dropdown"
import { Container } from "reactstrap"
import { isSameColumn, normalizeColumnValue } from "./columnSelectionUtils"

export default function TemplateButtons({
  selectedTemplateData,
  buttonVars = [],
  columns = [],
  selectedOptions = [],
  selectedButtonOptions = [],
  setSelectedButtonOptions = () => {},
  isSubmitted = false,
  selectFileColumn,
  selectNumber,
  selectedColumnHeader,
}) {
  const normalizedSelectedOptions = selectedOptions.map(normalizeColumnValue)
  const normalizedSelectedButtonOptions = selectedButtonOptions.map(
    normalizeColumnValue
  )

  const handleSelectButtonVariable = (column, index) => {
    const nextSelectedButtonOptions = [...selectedButtonOptions]
    nextSelectedButtonOptions[index] = normalizeColumnValue(column)
    setSelectedButtonOptions(nextSelectedButtonOptions)
  }

  return (
    <Container>
      {selectedTemplateData.components.map((component, componentIdx) => {
        if (component.type !== "BUTTONS") {
          return null
        }

        return component.buttons.map((button, buttonIdx) => {
          const buttonVarIndex = buttonVars.findIndex(
            buttonVar =>
              buttonVar.componentIndex === componentIdx &&
              buttonVar.buttonIndex === buttonIdx
          )
          const buttonVar = buttonVars[buttonVarIndex]
          const selectedButtonColumn = normalizeColumnValue(
            selectedButtonOptions[buttonVarIndex]
          )

          return (
            <React.Fragment key={`${button.text}-${buttonIdx}`}>
              <div className="template-button-variable-row mb-2">
                <button
                  type="button"
                  style={{
                    color: "#2a3042",
                    border: "1px solid #2a3042",
                    transition: "all 0.3s ease-in-out",
                  }}
                  className="d-block rounded-2 buttons-preview-template p-2 fs-6 bg-transparent b template-button-variable-trigger"
                >
                  {button.text}
                </button>

                {buttonVar && (
                  <div
                    style={{
                      direction: "ltr",
                    }}
                    className="template-button-variable-control"
                  >
                    <div className="template-button-variable-select">
                      <span className="template-button-variable-label">
                        {buttonVar.label}
                      </span>

                      <DropdownButton
                        className="dropdown-toggle-temp-preview-var template-button-variable-dropdown"
                        style={{
                          background: "white",
                          margin: "0",
                          direction: "ltr",
                        }}
                        title={
                          <div className="template-button-variable-dropdown-title">
                            <span className="text-truncate">
                              {selectedButtonColumn ||
                                "Choose the respective column"}
                            </span>
                            <i
                              style={{
                                color: "#ACB4BF",
                              }}
                              className="fas fa-chevron-down"
                            ></i>
                          </div>
                        }
                      >
                        {columns.map((column, index) => {
                          const normalizedColumn = normalizeColumnValue(column)

                          return (
                            <Dropdown.Item
                              disabled={
                                normalizedSelectedOptions.includes(
                                  normalizedColumn
                                ) ||
                                isSameColumn(selectFileColumn, normalizedColumn) ||
                                isSameColumn(selectNumber, normalizedColumn) ||
                                isSameColumn(
                                  selectedColumnHeader,
                                  normalizedColumn
                                ) ||
                                (normalizedSelectedButtonOptions.includes(
                                  normalizedColumn
                                ) &&
                                  normalizedSelectedButtonOptions[
                                    buttonVarIndex
                                  ] !== normalizedColumn)
                              }
                              onClick={() =>
                                handleSelectButtonVariable(
                                  normalizedColumn,
                                  buttonVarIndex
                                )
                              }
                              className="DropdownItem"
                              key={`${normalizedColumn}-${index}`}
                            >
                              {normalizedColumn}
                            </Dropdown.Item>
                          )
                        })}
                      </DropdownButton>
                    </div>

                    {!selectedButtonColumn && isSubmitted && (
                      <p
                        style={{
                          direction: "rtl",
                          textAlign: "right",
                        }}
                        className="text-danger mb-0 mt-1"
                      >
                        required
                      </p>
                    )}
                  </div>
                )}
              </div>
            </React.Fragment>
          )
        })
      })}
    </Container>
  )
}
